export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const normalizeSearchText = (value: string | null | undefined) =>
  typeof value === 'string' ? value.toLowerCase() : '';

export const includesSearchText = (
  value: string | null | undefined,
  searchTerm: string | null | undefined,
) => normalizeSearchText(value).includes(normalizeSearchText(searchTerm));

export const convertCamelCaseToMultipleWords = (text: string) => {
  const textSepareted = text.replace(/([A-Z])/g, ' $1');
  return textSepareted.charAt(0).toUpperCase() + textSepareted.slice(1);
};

export const getNameInitials = (name: string) => {
  if (!name) return '';
  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('');
  return initials.toUpperCase();
};

export const stringToColor = (string: string) => {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
};
